import { BATTERY_ENERGY_PERCENT } from './constant';

export const getBatteryEnergyImage = (batteryEnergyPercent) => {
  // 100
  if (batteryEnergyPercent === 100) {
    return BATTERY_ENERGY_PERCENT.P_100;
  }

  // 80 - 99
  if (batteryEnergyPercent >= 80) {
    return BATTERY_ENERGY_PERCENT.P_80;
  }

  // 50 - 79
  if (batteryEnergyPercent >= 50) {
    return BATTERY_ENERGY_PERCENT.P_50;
  }

  // 20 - 49
  if (batteryEnergyPercent >= 20) {
    return BATTERY_ENERGY_PERCENT.P_20;
  }

  return BATTERY_ENERGY_PERCENT.P_00;
};
